export function DefaultInput(props) {
  return (
    <>
      <input
        autoFocus={props.autoFocus}
        onChange={props.onChange}
        type={props.type}
        name={props.name}
        id={props.id}
        autoComplete={props.autoComplete}
        spellCheck={props.spellCheck}
        required={props.required}
        minLength={props.minLength}
        maxLength={props.maxLength}
        pattern={props.pattern}
        value={props.value}
        className="w-full py-2 px-0 block border-0 border-b-2 border-grayM focus:border-purple 
        focus:ring-0 sm:text-base hover:ring-0"
      />
    </>
  );
}

export function DefaultSelect(props) {
  return (
    <>
      <select
        autoFocus={props.autoFocus}
        onChange={props.onChange}
        type={props.type}
        name={props.name}
        id={props.id}
        autoComplete={props.autoComplete}
        spellCheck={props.spellCheck}
        required={props.required}
        minLength={props.minLength}
        maxLength={props.maxLength}
        pattern={props.pattern}
        value={props.value}
        className="w-full py-2 px-2 block border-0 border-b-2 border-grayM focus:border-purple 
        focus:ring-0 sm:text-base">
        {(props?.option ?? []).map((option, index) => {
          return (
            <option  key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </>
  );
}
